import styled from 'styled-components/macro';
import { device } from '../../styles/devices';

export const BannerContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;
export const HeaderContainer = styled.div`
  padding: 0px;
  @media ${device.mobileLrg} {
    padding: inherit;
  }
  @media ${device.laptop} {
    width: 1000px;
    margin: 0 auto;
    padding: 0px 30px 10px;
  }
`;
export const Banner = styled.img`
  width: 100%;
  display: none;
  @media ${device.mobileLrg} {
    display: block;
  }
`;

export const MobileBanner = styled.img`
  cursor: pointer;
  width: 100%;
  max-width: 560px;
  min-width: 200px;
  padding-bottom: 10px;
  @media ${device.mobileLrg} {
    display: none;
  }
`;
export const HeaderLogoSVG = styled.svg`
  cursor: pointer;
  width: 80%;
  max-width: 500px;
  min-width: 200px;
  padding: 20px;
  @media ${device.mobileLrg} {
    display: none;
  }
`;
